import { Action } from '@/store/workflow/actions'
import { DueTask, Process, TaskLog, VariablePayload } from '@/store/workflow/types'
import { wrapVariables } from '@/utils'
import { filter, IterateeShorthand } from 'lodash'
import Vue, { VNode } from 'vue'
import { ScopedSlotReturnValue } from 'vue/types/vnode'

export default Vue.extend({
  computed: {
    filters() {
      const filters: IterateeShorthand<TaskLog> = {}

      // select by task variable
      if (this.name) {
        filters.task_definition_key = this.name
      }

      // select by task id
      if (this.id) {
        filters.id = this.id
      }

      // select by process business key
      if (typeof this.inProcess === 'string') {
        filters.business_key = this.inProcess
      } else if (typeof this.inProcess === 'object') {
        filters.process_instance_id = this.inProcess.id
      }

      // select by case variable
      filters.case_id = this.case ? this.case : this.$store.getters.currentCaseId

      return filters
    },
    filteredDueTasks(): DueTask[] {
      const tasks: DueTask[] = this.$store.getters['workflow/dueTasks']
      return filter(tasks, this.filters)
    },
    filteredDoneTasks(): TaskLog[] {
      const tasks: TaskLog[] = this.$store.getters['workflow/doneTasks']
      return filter(tasks, this.filters)
    },
  },
  inject: {
    process: {
      default: null,
    },
  },
  props: {
    case: {
      type: String,
    },
    id: {
      type: String,
    },
    inProcess: {
      type: [String, Object as () => Process],
      default(): Process | null {
        return (this as any).process
      },
    },
    name: {
      type: String,
    },
    tag: {
      default: 'div',
      type: String,
    },
  },
  render(): VNode {
    const Tag = this.tag
    const dueTasks = this.filteredDueTasks
    const doneTasks = this.filteredDoneTasks

    let content: ScopedSlotReturnValue = []

    // for due tasks
    if (dueTasks.length > 0 && this.$scopedSlots.due) {
      const dueSlot = this.$scopedSlots.due
      content = content.concat(
        this.filteredDueTasks.map(task =>
          dueSlot({
            complete: (variables?: VariablePayload) => {
              const wrappedVariables = variables ? wrapVariables(variables) : {}
              return this.$store.dispatch({
                task,
                type: 'workflow/completeTask',
                variables: wrappedVariables,
              })
            },
            task,
          })
        )
      )

      content = content.concat(
        this.filteredDueTasks.map(task => (
          <portal to="due-tasks">
            <div class="task">
              {task.business_key}/{task.task_definition_key}
            </div>
          </portal>
        ))
      )
    }

    // for done tasks
    if (doneTasks.length > 0 && this.$scopedSlots.done) {
      const doneSlot = this.$scopedSlots.done
      content = content.concat(this.filteredDoneTasks.map(task => doneSlot({ task })))
    }

    // if no due or done task was found
    if (dueTasks.length + doneTasks.length === 0 && this.$slots.else) {
      content = content.concat(this.$slots.else)
    }

    if (content.length === 0) {
      return null
    }

    return <Tag {...this.$attrs}>{content}</Tag>
  },
})
